import { get } from '@/util/auth'

import { API_PATH_CARRIER_BYID } from './apiRoutes'

export const carrierServicesResources = {
  get: {
    carrierById: async () => get<string>(API_PATH_CARRIER_BYID, true),
  },
}
